module.exports = __webpack_public_path__ + "static/media/pig.358cf3ae.png";